import OrderTag from "@/enum/OrderTag";

const OrderTagNameMap = {
    [OrderTag.PRESALE]: "预售",

    [OrderTag.TMALL_HOME_DELIVERY]: "天猫送货上门",

    [OrderTag.TMALL_LOGISTICS_UPGRADE]: "天猫物流升级",

    [OrderTag.TMALL_LOGISTICS_SHIP_AS_REQUIRED]: "按需配送",

    [OrderTag.TMALL_LOGISTICS_SHIP_BY_SF]: "顺丰配送",

    [OrderTag.TMALL_LOGISTICS_PROMISE_SHIPPING]: "承诺发货",

    [OrderTag.TMALL_LOGISTICS_PROMISE_SERVED]: "承诺送到",

    [OrderTag.PDD_DESIGNATED_PACKAGE_MATERIAL]: "指定包材",

    [OrderTag.DESIGNATED_LOGISTICS]: "指定物流",

    [OrderTag.DOUDIAN_HOME_DELIVERY]: "送货上门",

    [OrderTag.JD_TRY_BEFORE_PAY_LATER]: "先用后付",

    [OrderTag.TB_DECORATION_ORDER]: "家装",

    [OrderTag.TB_PETTY_FEE_RECEIPT]: "小额收款",

    [OrderTag.DOUDIAN_HOME_DELIVERY_RECOMMENDED]: "推荐送货上门",

    [OrderTag.PDD_REGION_BLACK_DELAY_SHIPPING]: "发货时间可延迟",

    [OrderTag.FREE_SF]: "顺丰包邮",

    [OrderTag.SELF_CONTAINED]: "买家自提",

    [OrderTag.PDD_DELIVERY_ONE_DAY]: "当日发货",

    [OrderTag.PDD_NO_TRACE_DELIVERY]: "无痕发货",

    [OrderTag.JD_FULFILLMENT]: "京仓订单",

    [OrderTag.JD_HOME_DELIVERY_BULKY]: "大件送货上门",

    [OrderTag.JD_HOME_DELIVERY_LIGHT]: "送货上门",

    [OrderTag.PDD_SHIP_BY_SF]: "发顺丰",

    [OrderTag.PDD_COMMUNITY_GROUP]: "小区团购",

    [OrderTag.JD_DELIVERY]: "京配",

    [OrderTag.EXPEDITE_DELIVERY]: "催发货",

    [OrderTag.CONSOLIDATED_SHIPPING]: "集运",

    [OrderTag.TAOTIAN_CONSOLIDATED_SHIPPING]: "集运",

    [OrderTag.PDD_ALLERGY_REFUND]: "过敏包退",

    [OrderTag.ALI_SEND_ABOUT_TO_OVERDUE]: "发货即将超时",

    [OrderTag.ALI_SEND_OVERDUE]: "发货已超时",

    [OrderTag.ALI_DELIVER_OVERDUE]: "揽收已超时",

    [OrderTag.PDD_XINJIANG_CONSOLIDATE]: "新疆中转",

    [OrderTag.PDD_HK_CONSOLIDATE]: "香港集运",

    [OrderTag.PDD_MACAO_CONSOLIDATE]: "澳门集运",

    [OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE]: "哈萨克斯坦集运",

    [OrderTag.PDD_XIZANG_CONSOLIDATE]: "西藏中转",

    [OrderTag.PDD_JAPAN_CONSOLIDATE]: "日本集运",

    [OrderTag.PDD_TAIWAN_CONSOLIDATE]: "中国台湾集运",

    [OrderTag.PDD_KOREA_CONSOLIDATE]: "韩国集运",

    [OrderTag.PDD_SINGAPORE_CONSOLIDATE]: "新加坡集运",

    [OrderTag.PDD_MALAYSIA_CONSOLIDATE]: "马来西亚集运",

    [OrderTag.PDD_THAILAND_CONSOLIDATE]: "泰国集运",

    [OrderTag.PDD_VIETNAM_CONSOLIDATE]: "越南集运",

    [OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE]: "吉尔吉斯斯坦集运",

    [OrderTag.PDD_UZBEKISTAN_CONSOLIDATE]: "乌兹别克斯坦集运",

    [OrderTag.PDD_GANSU_CONSOLIDATE]: "甘肃集运",

    [OrderTag.PDD_NEIMENGGU_CONSOLIDATE]: "内蒙古集运",

    [OrderTag.PDD_NINGXIA_CONSOLIDATE]: "宁夏集运",

    [OrderTag.PDD_QINGHAI_CONSOLIDATE]: "青海集运",

    [OrderTag.ALI_DELIVERY_GUARANTEE]: "1688官方直送",

    [OrderTag.SHIP_HOLD]: "暂停发货",

    [OrderTag.FULL_PAYMENT_PRESALE]: "全款预售",

    [OrderTag.LOCKED]: "手动锁单",

    [OrderTag.PDD_COURIER_DOOR_TO_DOOR_COLLECT]: "快递上门揽收",

    [OrderTag.DOUBLE_ADDRESS]: "双地址",

    [OrderTag.LOCAL_DOUBLE_ADDRESS]: "骗运费双地址",

    [OrderTag.DOUDIAN_CONSOLIDATION_XINJIANG]: "新疆中转",

    [OrderTag.SHIPPING_DELAY]: "推迟发货",

    [OrderTag.KWAI_PRIORITY_DELIVERY]: "优先发货",

    [OrderTag.ALI_C2M_RESHIPMENT]: "补寄工单",

    [OrderTag.ORDER_ITEM_PART_QUANTITY_CANCELED]: "部分数量取消",

    [OrderTag.ORDER_ITEM_PART_QUANTITY_SHIPPED]: "部分数量发货",

    [OrderTag.ABNORMAL_ORDER]: "异常订单",

    [OrderTag.ALI_OUT_ORDER_TAOBAO]: "淘系加密分销",

    [OrderTag.ALI_OUT_ORDER_PDD]: "拼多多加密分销",

    [OrderTag.ALI_OUT_ORDER_DY]: "抖音加密分销",

    [OrderTag.ALI_OUT_ORDER_KWAI]: "快手加密分销",

    [OrderTag.ALI_OUT_ORDER_XHS]: "小红书加密分销",

    [OrderTag.ALI_OUT_ORDER_JD]: "京东加密分销",

    [OrderTag.ALI_OUT_ORDER_WEIXIN]: "微信小店加密分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO]: "淘系分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD]: "拼多多分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY]: "抖音分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI]: "快手分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS]: "小红书分销",

    [OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD]: "京东分销",

    [OrderTag.ALI_CAN_NOT_SHIP]: "不可发货",

    [OrderTag.TAOTIAN_PAID_FORBIN_CONSIGN]: "暂不可发货",

    [OrderTag.CANNOT_SHIP]: "不可发货",

    [OrderTag.ALI_CUSTOMIZATION]: "定制服务",

    [OrderTag.JD_PACKING_LIST_REQUIRED]: "配货清单",

    [OrderTag.DOUDIAN_SHIP_BY_SF]: "顺丰包邮",

    [OrderTag.DOUDIAN_PRIORITY_DELIVERY]: "优先发货",

    [OrderTag.BUYER_BLACKLIST]: "黑名单",

    [OrderTag.CANCEL_WAYBILL_RECYCLED]: "有回收运单号",

    [OrderTag.PDD_DELIVERY_APPOINTMENT]: "预约配送",

    [OrderTag.JL_OUT_ORDER_CHANNELSHOP]: "微信小店加密分销",

    [OrderTag.DOUDIAN_DELIVERY_APPOINTMENT]: "预约发货",

    [OrderTag.DOUDIAN_APPOINTMENT_ARRIVAL]: "承诺日达",

    [OrderTag.PDD_HOME_DELIVERY]: "送货上门",

    [OrderTag.KWAI_CONSOLIDATION_XINJIANG]: "新疆中转",

    [OrderTag.KWAI_CONSOLIDATION_NEIMENGGU]: "内蒙古中转",

    [OrderTag.KWAI_CONSOLIDATION_QINGHAI]: "青海中转",

    [OrderTag.KWAI_CONSOLIDATION_GANSU]: "甘肃中转",

    [OrderTag.KWAI_CONSOLIDATION_NINGXIA]: "宁夏中转",

    [OrderTag.KWAI_CONSOLIDATION_XIZANG]: "西藏中转",

    [OrderTag.CHANNELSHOP_QUALITY_INSPECTION]: "送检订单",

    [OrderTag.PDD_DIRECT_MAIL_ACTIVITY]: "直邮活动",

    [OrderTag.XHS_HOME_DELIVERY]: "送货上门",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_DOUDIAN]: "抖店加密",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_TAOBAO]: "淘宝加密",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_PDD]: "拼多多加密",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_KWAI]: "快手加密",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_JD]: "京东加密",

    [OrderTag.ENCRYPTED_MANUAL_ORDER_XHS]: "小红书加密",

    [OrderTag.ALI_CROSS_BORDER]: "跨境订单",

    [OrderTag.JD_ENCRYPTED_OUT_ORDER_DOUDIAN]: "云交易抖店加密订单",

    [OrderTag.JD_ENCRYPTED_OUT_ORDER_KWAI]: "云交易快手加密订单",

    [OrderTag.SAMPLE]: "样品",

    [OrderTag.DOUDIAN_REMOTE_DIRECT]: "偏远直邮",

    [OrderTag.DOUDIAN_CONSOLIDATION_XIZANG]: "西藏中转",

    [OrderTag.JD_CONSOLIDATION_XINJIANG]: "新疆集运",

    [OrderTag.DOUDIAN_ORDER_SUPPLY]: "供应链单",

    [OrderTag.JD_DELIVERY_APPOINTMENT]: "预约发货",

    [OrderTag.TAOTIAN_SHIP_BY_SF]: "加价发顺丰",

    [OrderTag.TAOTIAN_XINJIANG_CONSOLIDATE]: "新疆中转",

    [OrderTag.KWAI_SHIP_BY_SF]: "顺丰包邮",

    [OrderTag.KWAI_SHIP_BY_SF_RECOMMEND]: "推荐顺丰",

    [OrderTag.DOUDIAN_CONSOLIDATION_MERGE]: "合包发货",

    [OrderTag.PERIOD_PURCHASE]: "周期购",

    [OrderTag.PRESENT]: "送礼单",

    [OrderTag.SUBSIDY_SUPPLY_SALE]: "国补供销",

    [OrderTag.SUBSIDY_SELF_SALE]: "国补",

    [OrderTag.PDD_PROMISE_ARRIVAL]: "承诺送达",

    [OrderTag.DOUDIAN_APPOINTMENT_DELIVERY]: "预约发货",

    [OrderTag.DOUDIAN_APPOINTMENT_ARRIVAL_V2]: "预约送达",

    [OrderTag.DOUDIAN_PROMISE_ARRIVAL]: "承诺送达",

    [OrderTag.SUBSIDY_3C]: "国补3C",

    [OrderTag.SUBSIDY_MAJOR_APPLIANCE]: "国补大家电",

    [OrderTag.ALI_MANAGED_SHIPPING]: "托管订单",

    [OrderTag.LUCKY_MONEY]: "红包",

    [OrderTag.LH_CUSTOMIZATION]: "定制订单",

    [OrderTag.GREETING_CARD]: "礼物贺卡",

    [OrderTag.JD_PURCHASE]: "京东供销",

    [OrderTag.ALI_AE_DOOR_PICKUP]: "速卖通上门揽订单",

    [OrderTag.ALI_AE_SELF_SEND]: "速卖通自寄订单",

    [OrderTag.JD_HYPERLINK_ORDER]: "超链订单",

    [OrderTag.JD_HYPERLINK_SUBSIDY_ORDER]: "超链国补",

    [OrderTag.ORDER_ITEM_PART_BUNDLE_SKU_SHIPPED]: "组合品部分发货",

    [OrderTag.PDD_WEIPAI_SERVICE]: "微派服务",

    [OrderTag.DOUDIAN_GIFT_LATE_DELIVERY]: "赠品后发",

    [OrderTag.TAOTIAN_REISSUE]: "补发单",

    [OrderTag.SHIPPED_OR_SUCCESS_ITEM_WITH_AFTERSALE]: "有售后",

    [OrderTag.OPEN_IN_FESTIVAL]: "不打烊",

    [OrderTag.TAOTIAN_GOOFISH]: "闲鱼",

    [OrderTag.TAOTIAN_INSTANT_RETAIL_PLATFORM_DELIVERY]: "闪购-平台配送",

    [OrderTag.TAOTIAN_INSTANT_RETAIL_SELLER_DELIVERY]: "闪购-商家配送",

    [OrderTag.KWAI_TOMORROW_ARRIVAL]: "明日达",

    [OrderTag.KWAI_NEXT_DAY_ARRIVAL]: "隔日达",

    [OrderTag.DOUDIAN_PAID_SF_EXPRESS]: "加价发顺丰",

    [OrderTag.DOUDIAN_PAID_SF_EXPRESS_TK]: "发顺丰特快",

    [OrderTag.DOUDIAN_HIGH_QUALITY_EXPRESS]: "优质快递",

    [OrderTag.DOUDIAN_BUY_FREQUENCY]: "高频购买",

    [OrderTag.DOUDIAN_PRIORITY_SERVICE]: "服务优先",

    [OrderTag.DOUDIAN_SHOP_REGULAR_CUSTOMER]: "店铺老客",

    [OrderTag.DOUDIAN_TOMORROW_RECEIPT]: "明日达",

    [OrderTag.TAOTIAN_SUPER_LINK_ORDER]: "超链订单",

    [OrderTag.DOUDIAN_SHOP_INSTALLATION]: "商家安装",

    [OrderTag.TAOTIAN_OFFICIAL_IDENTIFICATION]: "官方鉴别",

    [OrderTag.ALI_FULFILLMENT_BY_WAREHOUSE]: "云仓代发",

    [OrderTag.PDD_FULFILLMENT_BY_SHARED_WAREHOUSE]: "拼多多共享仓",

    [OrderTag.DOUDIAN_SPRING_FESTIVAL_DELAY_SHIPPING]: "春节延迟发货",
    [OrderTag.INSTANT_SHIP]: "极速发货",

    [OrderTag.TAOTIAN_SHIP_BY_SF_JC]: "加价发顺丰集采",

    [OrderTag.TAOTIAN_URGENT_DELIVERY]: "加急发货",

    [OrderTag.JD_PET_ITEM]: "安心宠",

    [OrderTag.KWAI_PICK_UP_IN24H]: "24小时揽",

    [OrderTag.SHIP_BY_SF]: "加价发顺丰",

    [OrderTag.SHIP_BY_SF_EXPRESS]: "加价发顺丰标快",

    [OrderTag.SHIP_BY_SF_EXPRESS_TK]: "加价发顺丰特快",

    [OrderTag.QUALITY_INSPECTION]: "质检",
};

export default OrderTagNameMap;
